module.exports = __webpack_public_path__ + "img/LUB00411.e6e81050.png";